import { Ed25519PublicKey, TokenValidator } from '@dialectlabs/sdk';
import nacl from 'tweetnacl';
import { SOLANA_ED25519_TOKEN_SIGNER_ALG, SOLANA_ED25519_TOKEN_SIGNER_ALG_BACKWARD_COMPATIBLE, } from './solana-ed25519-token-signer';
export class SolanaEd25519TokenValidator extends TokenValidator {
    canValidate(tokenHeader) {
        return (tokenHeader.alg === SOLANA_ED25519_TOKEN_SIGNER_ALG ||
            tokenHeader.alg === SOLANA_ED25519_TOKEN_SIGNER_ALG_BACKWARD_COMPATIBLE);
    }
    isSignatureValid(token) {
        var _a;
        const signedPayload = token.base64Header + '.' + token.base64Body;
        const signingPayload = new TextEncoder().encode(signedPayload);
        return nacl.sign.detached.verify(signingPayload, token.signature, new Ed25519PublicKey((_a = token.body.sub_jwk) !== null && _a !== void 0 ? _a : token.body.sub).toBytes());
    }
    performExtraValidation(token) {
        if (!token.body.sub_jwk) {
            return true;
        }
        return token.body.sub === token.body.sub_jwk;
    }
}
//# sourceMappingURL=solana-ed25519-token-validator.js.map